import { useEffect, useRef } from "react";
import { services } from "@/mocks/services";
import { Link } from "react-router-dom";

export default function Services() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".reveal");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" ref={sectionRef} className="py-20 md:py-28 lg:py-32 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 md:mb-20">
            <span className="reveal text-accent-500 text-xs font-semibold tracking-[0.25em] uppercase mb-4 block">
              What We Offer
            </span>
            <h2 className="reveal font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              Our <span className="text-primary-600">Security Services</span>
            </h2>
            <p className="reveal text-foreground-600 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              Comprehensive security solutions tailored to meet your specific protection needs across all industries.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="reveal group bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 hover:border-primary-300 transition-all duration-500 hover:-translate-y-1"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 flex items-center justify-center bg-primary-100 rounded-xl mb-6 group-hover:bg-primary-500 transition-colors duration-500">
                  <i className={`${service.icon} text-primary-600 text-2xl group-hover:text-background-50 transition-colors duration-500`} />
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                  {service.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-primary-600 font-semibold text-sm hover:text-accent-500 transition-colors duration-300"
                >
                  Learn More
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}